import {assert} from 'Asserts';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import DocumentStore from 'notebook/documents/DocumentStore';
import EntryStore from 'stores/EntryStore';
import APIUtil from 'util/APIUtil';
import StageEntryStore from 'workflows/stage-entries/StageEntryStore';

/**
 * Returns true if the Entry, Document, or StageEntry can be edited.
 *
 * @param entryId - an API identifier
 */
export default function isEntryEditable(entryId: string): boolean | undefined {
  const entryType = APIUtil.apiIdToType(entryId);
  if (entryType === ModelTypeConstants.STAGE_ENTRY) {
    const editorState = StageEntryStore.getEditorState(entryId);
    const versionState = StageEntryStore.getVersionState(entryId);
    return (
      editorState != null &&
      versionState != null &&
      editorState.stageEntryDocument.permissions.writable &&
      versionState.isLatest &&
      !versionState.dirty
    );
  } else if (entryType === ModelTypeConstants.DOCUMENT) {
    const editorState = DocumentStore.getEditorState(entryId);
    const versionState = DocumentStore.getVersionState(entryId);
    return (
      editorState != null &&
      versionState != null &&
      editorState.document.permissions.writable &&
      versionState.isLatest &&
      !versionState.dirty
    );
  } else {
    assert(entryType === ModelTypeConstants.ENTRY, 'Unexpected entry type', {entryId});
    const editorState = EntryStore.getEditorState(entryId);
    const versionState = EntryStore.getVersionState(entryId);
    return (
      editorState != null &&
      versionState != null &&
      editorState.entry.permissions.writable &&
      versionState.isLatest &&
      !versionState.dirty
    );
  }
}
